import React, { useEffect, useRef, useState, useMemo } from 'react'
import { connect } from "react-redux";
import classnames from "classnames";
import moment from "moment";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import SimpleBar from 'simplebar-react';
import user2 from "../../assets/images/users/user-2.jpg";
import { Card, CardBody, Dropdown, Col, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavLink, NavItem, TabContent, TabPane, Row, UncontrolledDropdown, Button, Input, UncontrolledAlert } from 'reactstrap';
import { Link } from 'react-router-dom';

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    deleteMessage as onDeleteMessage,
    addMessage as onAddMessage,
    getChats as onGetChats,
    getContacts as onGetContacts,
    getGroups as onGetGroups,
    getMessages as onGetMessages,
} from "store/actions";
import Spinners from 'components/Common/Spinner';

const Chat = (props) => {
    document.title = "Chat | Lexa - Responsive Bootstrap 5 Admin Dashboard";

    const breadcrumbItems = [
        { title: "Rakops Solutions", link: "#" },
        { title: "Communications", link: "#" },
        { title: "Chat", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Chat', breadcrumbItems)
    })

    const [singlebtn, setSinglebtn] = useState(false)
    const [singlebtn1, setSinglebtn1] = useState(false)
    const [singlebtn2, setSinglebtn2] = useState(false)


    const dispatch = useDispatch();

    const selectChatState = (state) => state.chat;
    const ChatProperties = createSelector(
        selectChatState,
        (Chat) => ({
            chats: Chat.chats,
            groups: Chat.groups,
            contacts: Chat.contacts,
            messages: Chat.messages,
            loading: Chat.loading
        })
    );

    const { chats, groups, contacts, messages, loading } = useSelector(ChatProperties);
    const [messagesData, setMessagesData] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(loading);
    }, [loading]);

    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const user = authUser ? (authUser.user || authUser) : null;
    const [currentUserId, setCurrentUserId] = useState(null);
    const [selectedContact, setSelectedContact] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredChats = useMemo(() => {
        return (chats || []).filter(chat =>
            (`${chat.first_name || ''} ${chat.last_name || ''}`).toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [chats, searchQuery]);

    const filteredContacts = useMemo(() => {
        return (contacts || []).filter(contact =>
            (`${contact.first_name || ''} ${contact.last_name || ''}`).toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [contacts, searchQuery]);

    const [activeTab, setactiveTab] = useState("1");
    const [Chat_Box_Username, setChat_Box_Username] = useState("");
    // eslint-disable-next-line no-unused-vars
    const [Chat_Box_User_Status, setChat_Box_User_Status] = useState("online");
    const [curMessage, setcurMessage] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [isdisable, setDisable] = useState(false);

    useEffect(() => {
        dispatch(onGetChats());
        dispatch(onGetContacts());
    }, [dispatch]);

    useEffect(() => {
        if (currentUserId) {
            dispatch(onGetMessages(currentUserId));
        }
    }, [currentUserId, dispatch]);


    useEffect(() => {
        setMessagesData(messages)
    }, [messages])

    const toggleTab = tab => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };

    //Use For Chat Box
    const userChatOpen = (contact) => {
        setChat_Box_Username(contact.first_name + " " + contact.last_name);
        setChat_Box_User_Status(contact.status)
        setCurrentUserId(contact.id);
        setSelectedContact(contact);
        dispatch(onGetMessages(contact.id));
    };

    // search data 
    // const handeleSearch = (ele) => {
    //     handleSearchData({ setState: setMessagesData, data: messages, item: ele.value })
    // }
    const currentTime = new Date();
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const time = `${hours}: ${minutes}`
    const addMessage = () => {
        if (curMessage !== "" && currentUserId) {
            const newMessage = {
                receiver_id: currentUserId,
                message: curMessage,
            };
            dispatch(onAddMessage(newMessage));
            setcurMessage("");
            setDisable(false)
        }
    };


    const onKeyPress = e => {
        if (e.key === "Enter") {
            e.preventDefault();
            addMessage();
        }
    };




    const [deleteMsg, setDeleteMsg] = useState("");
    const toggle_deleMsg = (id) => {
        setDeleteMsg(!deleteMsg);
        dispatch(onDeleteMessage(id))
    };

    const [copyMsgAlert, setCopyMsgAlert] = useState(false);
    const copyMsg = (ele) => {
        var copyText = ele.closest(".conversation-list").querySelector("p").innerHTML;
        navigator.clipboard.writeText(copyText);
        setCopyMsgAlert(true)
        if (copyText) {
            setTimeout(() => {
                setCopyMsgAlert(false)
            }, 1000)

        }
    };

    // scroll simple bar
    const scroollRef = useRef(null);
    useEffect(() => {
        if (scroollRef.current) {
            scroollRef.current.getScrollElement().scrollTop = scroollRef.current.getScrollElement().scrollHeight;
        }
    }, [messages])


    return (
        <React.Fragment>

            <div className="d-lg-flex">
                <Card className="chat-leftsidebar">
                    <CardBody>

                        <div className="text-center bg-light rounded px-4 py-4">
                            <div className="chat-user-status">
                                {user && user.avatar ?
                                    <img src={user.avatar} className="avatar-md rounded-circle" alt="" />
                                    :
                                    <div className="avatar-md mx-auto">
                                        <span className="avatar-title rounded-circle bg-primary text-white font-size-24">
                                            {user ? user.first_name.charAt(0) : 'U'}
                                        </span>
                                    </div>
                                }
                                <div className="">
                                    <div className="status online"></div>
                                </div>
                            </div>
                            <h5 className="font-size-16 mb-1 mt-3"><Link to="#" className="text-reset">{user ? `${user.first_name} ${user.last_name}` : "Utilisateur"}</Link></h5>
                            <p className="text-muted mb-0">Disponible</p>
                        </div>
                    </CardBody>

                    <div className="px-3 pb-3">
                        <div className="search-box position-relative">
                            <Input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="form-control rounded border ps-5"
                                placeholder="Rechercher..."
                            />
                            <i className="mdi mdi-magnify search-icon"></i>
                        </div>
                    </div>

                    <div className="chat-leftsidebar-nav">
                        <Nav pills justified className="bg-light mx-3 mb-3 rounded">
                            <NavItem >
                                <NavLink
                                    className={classnames({
                                        active: activeTab === "1",
                                    })}
                                    onClick={() => {
                                        toggleTab("1");
                                    }}
                                >
                                    <i className="bx bx-chat font-size-20 d-sm-none"></i>
                                    <span className="d-none d-sm-block">Chat</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTab === "2",
                                    })}
                                    onClick={() => {
                                        toggleTab("2");
                                    }}
                                >
                                    <i className="bx bx-book-content font-size-20 d-sm-none"></i>
                                    <span className="d-none d-sm-block">Contacts</span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <SimpleBar className="chat-message-list">
                                    <div className="pt-3">
                                        <div className="px-3">
                                            <h5 className="font-size-14 mb-3">Récents</h5>
                                        </div>
                                        <ul className="list-unstyled chat-list p-3">
                                            {
                                                isLoading ? <Spinners setLoading={setLoading} /> :
                                                    <SimpleBar>
                                                        {filteredChats.length > 0 ? (filteredChats.map((chat) => (
                                                            <li
                                                                key={chat.id}
                                                                className={
                                                                    currentUserId === chat.id
                                                                        ? "active"
                                                                        : ""
                                                                }
                                                            >
                                                                <Link
                                                                    to="#"
                                                                    onClick={() => {
                                                                        userChatOpen(chat);
                                                                    }}
                                                                >
                                                                    <div className="d-flex align-items-center">
                                                                        <div className={`flex-shrink-0 user-img ${chat.status || 'online'} align-self-center me-3`}>
                                                                            {chat.avatar ?
                                                                                <img src={chat.avatar} className="rounded-circle avatar" alt="" />
                                                                                :
                                                                                <div className="avatar align-self-center">
                                                                                    <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-16">
                                                                                        {chat.first_name ? chat.first_name.charAt(0) : '?'}
                                                                                    </span>
                                                                                </div>
                                                                            }
                                                                            <span className="user-status"></span>
                                                                        </div>

                                                                        <div className="flex-grow-1 overflow-hidden">
                                                                            <h5 className="text-truncate font-size-15 mb-0">{chat.first_name} {chat.last_name}</h5>
                                                                            <p className="text-muted mb-0 mt-1 text-truncate">{chat.last_message || ''}</p>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </li>
                                                        ))) : (
                                                            <li className="p-3 text-center text-muted">Aucune discussion récente</li>
                                                        )}
                                                    </SimpleBar>
                                            }
                                        </ul>
                                    </div>
                                </SimpleBar>
                            </TabPane>

                            <TabPane tabId="2">
                                <SimpleBar className="chat-message-list">
                                    <div className="pt-3">
                                        <div className="px-3">
                                            <h5 className="font-size-14 mb-3">Contacts</h5>
                                        </div>

                                        <div className="p-3 pt-0">
                                            {filteredContacts.length > 0 ? filteredContacts.map(contact => (
                                                <div key={contact.id}>
                                                    <ul className="list-unstyled chat-list">
                                                        <li className={currentUserId === contact.id ? "active" : ""}>
                                                            <Link
                                                                to="#"
                                                                onClick={() => {
                                                                    userChatOpen(contact);
                                                                }}
                                                            >
                                                                <h5 className="font-size-13 mb-0">{contact.first_name} {contact.last_name}</h5>
                                                                <p className="text-muted mb-0 font-size-12">{contact.email}</p>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )) : (
                                                <p className="text-center text-muted">Aucun contact trouvé</p>
                                            )}
                                        </div>
                                    </div>
                                </SimpleBar>
                            </TabPane>
                        </TabContent>
                    </div>

                </Card>


                <div className="w-100 user-chat mt-4 mt-sm-0 ms-lg-3">
                    <Card>
                        <div className="p-3 px-lg-4 border-bottom">
                            <Row>
                                <Col xl={4} className="col-7">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 avatar me-3 d-sm-block d-none">
                                            {selectedContact && selectedContact.avatar ?
                                                <img src={selectedContact.avatar} alt="" className="img-fluid d-block avatar rounded-circle" />
                                                :
                                                <div className="avatar">
                                                    <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-16">
                                                        {selectedContact ? selectedContact.first_name.charAt(0) : '?'}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                        <div className="flex-grow-1">
                                            <h5 className="font-size-16 mb-1 text-truncate"><Link to="#" className="text-reset">{Chat_Box_Username || 'Sélectionnez un contact'}</Link></h5>
                                            <p className="text-muted text-truncate mb-0">En ligne</p>
                                        </div>
                                    </div>
                                </Col>
                                <Col xl={8} className="col-5">
                                    <ul className="list-inline user-chat-nav text-end mb-0">
                                        <li className="list-inline-item">
                                            <Dropdown
                                                isOpen={singlebtn1}
                                                toggle={() => setSinglebtn1(!singlebtn1)}
                                            >
                                                <DropdownToggle className="btn nav-btn" tag="a">
                                                    <i className="bx bx-search"></i>
                                                </DropdownToggle>
                                                <DropdownMenu className="dropdown-menu-end dropdown-menu-md p-2">
                                                    <form className="px-2">
                                                        <div>
                                                            <input type="text" className="form-control border bg-light-subtle" placeholder="Rechercher..." />
                                                        </div>
                                                    </form>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </li>

                                        <li className="list-inline-item">
                                            <Dropdown
                                                isOpen={singlebtn2}
                                                toggle={() => setSinglebtn2(!singlebtn2)}
                                            >
                                                <DropdownToggle className="btn nav-btn" tag="a">
                                                    <i className="bx bx-dots-horizontal-rounded"></i>
                                                </DropdownToggle>
                                                <DropdownMenu className="dropdown-menu-end">
                                                    <DropdownItem >Profile</DropdownItem>
                                                    <DropdownItem >Archive</DropdownItem>
                                                    <DropdownItem >Muted</DropdownItem>
                                                    <DropdownItem >Delete</DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                        </div>

                        <SimpleBar ref={scroollRef} className="chat-conversation p-4">
                            {isLoading ? (<Spinners setLoading={setLoading} />) : (
                                <ul className="list-unstyled mb-0">
                                    {(messagesData || []).map((message, index) => {
                                        const isMyMessage = user && message.sender_id === user.id;
                                        return (
                                            <li key={index} className={isMyMessage ? "right" : ""}>
                                                <div className="conversation-list">
                                                    <div className="d-flex">
                                                        <div className="flex-1 ms-3">
                                                            <h5 className="font-size-16 conversation-name align-middle">
                                                                {isMyMessage ? "Vous" : Chat_Box_Username}
                                                            </h5>
                                                            <div className="ctext-wrap">
                                                                <div className="ctext-wrap-content">
                                                                    <p className="mb-0">{message.message}</p>
                                                                </div>
                                                            </div>
                                                            <p className="chat-time mb-0 mt-1 text-muted font-size-12">
                                                                <i className="bx bx-time-five align-middle me-1"></i>
                                                                {moment(message.created_at).format('HH:mm')}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </SimpleBar>
                        {copyMsgAlert && <UncontrolledAlert color='warning' dismissible role="alert">  Message copied</UncontrolledAlert>}
                        <div className="p-3 border-top">
                            <div className="row">
                                <div className="col">
                                    <div className="position-relative">
                                        <input type="text"
                                            value={curMessage}
                                            onKeyPress={onKeyPress}
                                            onChange={e => { setcurMessage(e.target.value); setDisable(true) }}
                                            className="form-control border chat-input" placeholder="Entrez votre message..." />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <Button
                                        type="button"
                                        color="primary"
                                        disabled={!isdisable}
                                        onClick={() => addMessage()}
                                        className="chat-send w-md waves-effect waves-light">
                                        <span className="d-none d-sm-inline-block me-2">
                                            Envoyer</span> <i className="mdi mdi-send float-end"></i></Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>

            </div>


        </React.Fragment >
    )
}

export default connect(null, { setBreadcrumbItems })(Chat);
